import { localStore } from 'services/browserStorage';
import { SBatchDetails, SGRNEntry } from './types';
import { StoreUtils } from 'utils/util';

export const GrnEntryUtils = {
  getItemRemainingQty: (poQty: number, batchDetails: SBatchDetails[], batchIndex: number) =>
    poQty -
    +batchDetails.reduce(
      (acc, item, index) => acc + (index === batchIndex ? 0 : +item.receivedQty),
      0,
    ),
  allowAddBatch: (poQty: number, batchDetails: SBatchDetails[]) =>
    poQty - +batchDetails.reduce((acc, item) => acc + +item.receivedQty, 0) > 0,
  saveLocalDraft: (draftIndex: string, data: object) => {
    localStore.set(`GRN_${StoreUtils.getKeyFromActiveSession(['cid'])}_${draftIndex}`, data);
    localStore.set(
      'localDraftId',
      `GRN_${StoreUtils.getKeyFromActiveSession(['cid'])}_${draftIndex}`,
    );
    localStore.set('localDraftSavedAt', Date.now() / 1000);
  },
  saveLocalDraftByName: (name: string, data: object) => {
    localStore.set(name, data);
    localStore.set('localDraftId', name);
    localStore.set('localDraftSavedAt', Date.now() / 1000);
  },
  getLastLocalDraftTimeStamp: () => localStore.get('localDraftSavedAt'),
  fetchLocalDraft: (draftIndex: string) =>
    localStore.get(`GRN_${StoreUtils.getKeyFromActiveSession(['cid'])}_${draftIndex}`),
  clearLocalDraftByName: (draftName: string) => {
    localStore.remove(draftName);
    localStore.remove('localDraftId');
    localStore.remove('localDraftSavedAt');
  },
  clearLocalDraftById: (draftId: string) => {
    localStore.remove(`GRN_${StoreUtils.getKeyFromActiveSession(['cid'])}_${draftId}`);
    localStore.remove('localDraftId');
    localStore.remove('localDraftSavedAt');
  },
  fetchLocalDraftId: () => localStore.get('localDraftId'),
  calculateTotalGrn: (rows: SGRNEntry[]): number =>
    rows.reduce((acc, row) => {
      if (row.batchDetails.length > 1) {
        return acc + 1;
      } else if (row.batchDetails.length === 1) {
        if (row.batchDetails[0].acceptedQty === row.poQty) {
          return acc + 1;
        } else if (row.batchDetails[0].receivedQty !== '') {
          return acc + 1;
        }
      }
      return acc;
    }, 0),
};
